import { StatoOrdineStatusPosizioneToOrdineMap } from "@components/atoms/StatoOrdine/StatoOrdine"
import useTrans from "@hooks/useTrans"
import { OrdineDetailType, PersonalizzazioneOrdineType, StatoPersonalizzazioneChoices, TempoProduzioneType } from "@utils/types"

export const SCAGLIONI_QUANTITA = [1, 50, 100, 250, 500, 1000, 2500, 5000, 10000] as const

export type LeadTimeColumn = {
  key: string
  label?: string
  render?: (item: TempoProduzioneType) => React.ReactNode
  align?: 'left' | 'center' | 'right'
  style?: string
  getSortValue?: (item: TempoProduzioneType) => any
}

const resolveTecnica = (item: TempoProduzioneType) => item.tecnica
const resolveCodiceFiglio = (item: TempoProduzioneType) => item.codiceFiglio


export const resolveColoriDimensione = (item: TempoProduzioneType) => {
  const driver = item.driver?.toUpperCase()
  if (driver === 'C') return resolveNumeroColori(item)
  if (driver === 'M') return item.areaStampa
  return resolveNumeroColori(item)
}

export const resolveNumeroColori = (item: TempoProduzioneType) => {
  const numeroColori = item.numeroColori
  if (!numeroColori) return '-'

  if (numeroColori.fullColor) {
    return numeroColori.nome || 'FULLCOLOR'
  }

  return numeroColori.numeroColori ?? numeroColori.nome ?? numeroColori.codice ?? '-'
}

const sortValue = (value?: string | number | null) => {
  if (value === undefined || value === null) return ''
  return value.toString().toLowerCase()
}

const getColoriDimensioneSortValue = (item: TempoProduzioneType) => {
  const stringValue = resolveColoriDimensione(item)
  return sortValue(stringValue)
}

export const DRIVER_LABELS: Record<string, string> = {
  C: 'Colore',
  M: 'Dimensione',
}

const resolveDriverLabel = (item: TempoProduzioneType, t: ReturnType<typeof useTrans>) => {
  const raw = item.driver
  if (!raw) return '-'
  const key = raw.toUpperCase()
  const label = DRIVER_LABELS[key] || raw
  return t(label)
}

export const generateLeadTimeColumns = (t: ReturnType<typeof useTrans>): LeadTimeColumn[] => {
  return [
    { key: 'tecnica', label: t('Tecnica'), render: (item) => resolveTecnica(item)?.nome, getSortValue: (item) => sortValue(resolveTecnica(item)?.nome) },
    { key: 'driver', label: t('Driver'), render: (item) => resolveDriverLabel(item, t), getSortValue: (item) => sortValue(item.driver) },
    { key: 'codice_padre', label: t('Codice padre'), render: (item) => resolveTecnica(item)?.codiceWeb, getSortValue: (item) => sortValue(resolveTecnica(item)?.codiceWeb) },
    { key: 'codice_figlio', label: t('Codice figlio'), render: (item) => resolveCodiceFiglio(item) || '-', getSortValue: (item) => sortValue(resolveCodiceFiglio(item)) },
    { key: 'colori_dim', label: t('Colori/Dim. stampa'), render: (item) => resolveColoriDimensione(item), getSortValue: getColoriDimensioneSortValue },
    { key: 'fornitore', label: t('Fornitore'), render: (item) => item.fornitore?.ragioneSociale, getSortValue: (item) => sortValue(item.fornitore?.ragioneSociale) },
  ]
}

export const getStatoPersonalizzazione = (personalizzazione: PersonalizzazioneOrdineType, ordine: OrdineDetailType) => {
  if (['ORDINE_ANNULLATO', 'ORDINE_EVASO', 'IN_LAVORAZIONE'].includes(ordine.statoOrdineCalcolato))
    return ordine.statoOrdineCalcolato
  const index_stati = personalizzazione.posizioniPersonalizzazioneOrdine.map((pos) => Object.keys(StatoOrdineStatusPosizioneToOrdineMap).indexOf(pos.statoPosizionePersonalizzazione))
    .filter(i => i >= 0)
  if (index_stati.length == 0)
    return undefined
  return Object.keys(StatoOrdineStatusPosizioneToOrdineMap)?.[Math.min(...index_stati)] as StatoPersonalizzazioneChoices
}
